import { Base } from "../core/base.model";
import { EmpleadoHorario } from "./empleado-horario.model";
import { HorarioLaboral, HorarioLaboralComida } from "./horario-laboral.model";

export class JornadaLaboral extends Base {
  idEmpleado: number;
  fechaReferencia: Date;
  diaSemana: number;
  horarioAsignado: boolean;
  diaConfigurado: boolean;
  minutosComida: number;
  minutosLaboralesObjetivo: number;
  horaEntrada: string | Date;
  horaSalida: string | Date;
  bloquesComida: HorarioLaboralComida[] = [];
  horarioLaboral: HorarioLaboral;
  asignacionHorario: EmpleadoHorario;
}
